/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Box, DialogContent, Button, Alert, TextField } from "@mui/material";
import Modal from "../Modal/Modal";

import { addToast as addToastAction } from "../../actions/toasts";

import {
  createImportance as createImportanceAction
} from "../../actions/importances";
import {
  listImportances as listImportancesSelector
} from "../../selectors/importances";
import withStepper from "../Modal/withStepper";

const initialState = {
  name: "",
};

class AddImportanceModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { ...initialState };
  }

  changeInput(inputName, event) {
    const { value } = event.target;

    this.setState(() => ({ [inputName]: value }));
  }

  async addImportance() {
    const {
      name
    } = this.state;

    const { createImportance, addToast } = this.props;

    const ret = await createImportance({
      name: name.trim()
    });

    if (ret.isSuccess) {
      addToast("success", "Success", "Importance successfully added!");
      this.closeModal();
    } else {
      addToast("error", "Error", "Error while adding importance. Try again.");
    }
  }

  closeModal() {
    const { closeAddModal } = this.props;

    this.setState(initialState);
    closeAddModal();
  }

  isNameValid() {
    const { name } = this.state;

    return name?.length !== 0;
  }

  isNameExist() {
    const { name } = this.state;
    const { importances } = this.props;

    if (this.isNameValid() && importances) {
      return importances.find(i => (i.name || "").toLowerCase().trim() === (name || "").toLowerCase().trim());
    }
    return false;
  }

  modalContent() {
    const { name } = this.state;
    const { isLastStep, stepperComponent } = this.props;

    const isNameValid = this.isNameValid() && !this.isNameExist();
    const isNameExist = this.isNameExist();

    return (
      <DialogContent sx={{ display: "flex", gap: 3, flexDirection: "column", marginTop: 1, width: "80%", alignItems: "center", alignSelf: "center" }}>
        {stepperComponent}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {isNameExist && <Alert severity="error">
            Importance name is already taken
          </Alert>}
          <TextField label="Name*" inputProps={{ readOnly: isLastStep }} error={!isNameValid} value={name} onChange={e => this.changeInput("name", e)}/>
        </Box>
      </DialogContent>
    );
  }

  modalActions() {
    const { currentStep, previousStep, nextStep, isLastStep } = this.props;
    const isNameValid = this.isNameValid() && !this.isNameExist();

    return (
      [
        <Button variant="outlined"
          key="cancel"
          onClick={() => {
            this.closeModal();
          }} >
            Cancel
        </Button>,
        currentStep > 0 && <Button variant="outlined"
          key="previous"
          onClick={() => {
            previousStep();
          }}>
            Previous
        </Button>,
        !isLastStep && <Button variant="contained"
          key="next"
          disabled={!isNameValid}
          color="secondary"
          onClick={() => {
            nextStep();
          }}>
            Next
        </Button>,
        isLastStep && <Button variant="contained"
          key="save"
          color="secondary"
          onClick={() => {
            this.addImportance();
          }}>
            Save
        </Button>
      ]
    );
  }

  render() {
    const { modalOpened } = this.props;

    return (
      <Modal
        isOpen={modalOpened}
        closeModal={() => this.closeModal()}
        title="Add importance"
        customModalContent={() => this.modalContent()}
        actions={() => this.modalActions()}
        actionAlign="flex-end"
      >
      </Modal>
    );
  }
}

AddImportanceModal.propTypes = {
  importances: PropTypes.arrayOf(PropTypes.object).isRequired,

  modalOpened: PropTypes.bool.isRequired,
  closeAddModal: PropTypes.func.isRequired,

  currentStep: PropTypes.number,
  previousStep: PropTypes.func,
  nextStep: PropTypes.func,
  stepperComponent: PropTypes.object,
  isLastStep: PropTypes.bool,

  createImportance: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    importances: listImportancesSelector(state)
  };
}

const mapDispatchToProps = {
  createImportance: createImportanceAction,
  addToast: addToastAction
};

export default connect(mapStateToProps, mapDispatchToProps)(withStepper(
  AddImportanceModal, [
    "Set importance information",
    "Sumup"
  ]));
